export default {
	service: ["Service", "Event", "Withdrawal", "Deposit", "T & C", "Certificate", "FAQs", "About", "VIP"],
	sign: {
		title: "Signed in for {0} day",
		SignIn: "Sign In"
	},
	work: {
		title: "Order Submission Reward",
		SignIn: "Get"
	},
	hotMusicAlbum: "Hot Music Album",
	hotMusic: "Hot Song Charts",
	popular: "New Playing",
	rankings: "Popular movies",
	top: "TOP{0}",
	OnchainServices: "Onchain Services",
	Real: {
		title: "Real-time",
		list: [
			"Total Online Users",
			"Average User Optimization Volume",
			"Optimization Needs Heatmap",
			"Platform Promotion Optimization Quantity"
		]
	},
	Profit: {
		Profit: "Profit",
		tabs: ["Profit", "Bonus", "Account"],
		TotalBalance: "Total balance",
		TotalLuckyBonus: "Total Lucky Bonus",
		todayEarnings: "Today's Earnings",
		availableBalance: "Available Balance",
		title: ["Today's Earnings", "Total Earnings", "Account"],
		list: ["Order Earnings", "Team Earnings", "Total Earnings"],
		order: {
			title: "Order Profit",
			commission: "Order Commission",
			amount: "Order Amount"
		},
		Analysis: {
			title: "Profit Analysis",
			tips: "You've made {0} transactions",
			tabs: ["Today's Profit", "Total Profit"],
			totalTitle: ["Order Profit", "Check-in Profit", "Team Profit", "Bonus Profit"]
		}
	},
	CustomerService: {
		title: "Customer Service Center",
		consultation: "Customer service consultation",
		btn: "Contact US",
		noticeTitle: "System Notification"
	},
	addWallet: "Add Wallet",
	taskProgress: "Daily Tasks Progress",
	currentProgress: "Current Task Progress",
	awardsBulletin: `{0}  user wins {1} {2} prize in the task.`,
	vip: {
		title: "@:vip.title",
		more: "View More"
	},
	stats: {
		title: "Data Sources - Dashboard & API",
		subTitle: "Artist stats",
		list: ["Metrics", "Artists with active socials", "Refreshed daily"]
	}
};
